import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { DocLink } from '@/pages/cade/SeiPanel';
import { fetchCadeSei } from '@/services/cade';

/**
 * The SEI votes placed under this decision's session, linked. Shares the case's SEI query (one
 * request per case, whatever the number of decision cards), and draws nothing when the ledger
 * cannot answer or no vote was signed in the window: the SEI panel above states why.
 */
export function SeiVoteLinks({
  caseKey,
  sessionDate,
}: {
  caseKey: string;
  sessionDate: string | null | undefined;
}) {
  const { t } = useTranslation(['cade']);
  const { data } = useQuery({
    queryKey: ['cade', 'sei', caseKey],
    queryFn: () => fetchCadeSei(caseKey),
    retry: false,
  });
  if (!sessionDate) return null;
  const votes =
    data?.sei.value?.sessions.find((s) => s.session_date === sessionDate)?.votes ?? [];
  if (votes.length === 0) return null;
  return (
    <div className="text-xs" data-sei-vote-links>
      <span className="text-muted-foreground">{t('cade:case.sei.votesHere')}</span>
      {votes.map((vote) => (
        <DocLink key={vote.sei_doc_number} doc={vote} />
      ))}
    </div>
  );
}
